import { render, staticRenderFns } from "./header-admin-public-switch.vue?vue&type=template&id=a1c57740&scoped=true&"
import script from "./header-admin-public-switch.vue?vue&type=script&lang=ts&"
export * from "./header-admin-public-switch.vue?vue&type=script&lang=ts&"
import style0 from "./header-admin-public-switch.vue?vue&type=style&index=0&id=a1c57740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c57740",
  null
  
)

export default component.exports